import { defineMessages } from 'react-intl';

const messages = defineMessages({
  message: {
    id: 'NoInformationAvailable.Message',
    defaultMessage: 'No Information Available',
  },
});

export default messages;
